import { render, staticRenderFns } from "./select-task-status.vue?vue&type=template&id=abe822ce&"
import script from "./select-task-status.vue?vue&type=script&lang=ts&"
export * from "./select-task-status.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports